import { orderedSteps, stepIndices } from 'shared';
import { CampaignFormStepDataMap, CampaignStep, StepStates } from 'types';

export const getStepIndex = (step: CampaignStep) => stepIndices[step] ?? -1;

export const getStepStates = (stepsData: CampaignFormStepDataMap) =>
  orderedSteps.reduce((acc, step) => {
    acc[step] = stepsData[step].state;

    return acc;
  }, {} as StepStates);

export const getNextStep = (currentStep: CampaignStep, advanceBy = 1): CampaignStep | undefined => {
  const currentIndex = stepIndices[currentStep];
  return orderedSteps[currentIndex + advanceBy];
};
